import React, { PureComponent } from 'react';
import memoize from 'lodash/memoize';

import { Button } from 'components';
import { ICON_MAINTENANCE, ERROR_UNAUTHORIZED } from 'assets';

import { JsBridge } from 'utils';

import config from './UnavailablePage.page.config';
import './UnavailablePage.page.style.less';
import text from './UnavailablePage.page.translation';

import packageInfo from '../../../package.json';

class UnavailablePage extends PureComponent {
  _onBack = e => {
    e && e.preventDefault();

    if (window.IS_IN_SKYWALKER) JsBridge.close();
  };

  componentDidMount() {
    JsBridge.on('back', this._onBack);
  }

  componentWillUnmount() {
    JsBridge.off('back', this._onBack);
  }

  _createMaintenanceConfig = memoize(() => {
    const {
      intl: { formatMessage, locale },
      description,
    } = this.props;

    return {
      imgSource: ICON_MAINTENANCE,
      title: description
        ? description[locale].title || formatMessage(text.maintenance.title)
        : formatMessage(text.maintenance.title),
      description: description
        ? description[locale].body ||
          formatMessage(text.maintenance.description)
        : formatMessage(text.maintenance.description),
      buttonText: formatMessage(text.maintenance.btn),
    };
  });

  _createErrorConfig = memoize(() => {
    const {
      intl: { formatMessage },
    } = this.props;

    return {
      imgSource: ERROR_UNAUTHORIZED,
      title: formatMessage(text.unauthorized.title),
      description: formatMessage(text.unauthorized.description),
      buttonText: formatMessage(text.unauthorized.btn),
    };
  });

  _renderUnavailableContent = () => {
    const { isUnauthorized } = this.props;
    const { imgSource, title, description, buttonText } = isUnauthorized
      ? this._createErrorConfig()
      : this._createMaintenanceConfig();

    return (
      <>
        <div className="body">
          <img
            className="icon-maintenance"
            src={imgSource}
            alt="icon maintenance"
          />
          <span className="title">{title}</span>
          <span className="description">{description}</span>
        </div>
        {isUnauthorized && (
          <div className="version-info">v{packageInfo.version}</div>
        )}
        <div className="footer">
          <Button type="full primary" action={this._onBack}>
            <span className="button-text">{buttonText}</span>
          </Button>
        </div>
      </>
    );
  };

  render() {
    return <div id="unavailable-page">{this._renderUnavailableContent()}</div>;
  }
}

UnavailablePage.displayName = config.displayName;
UnavailablePage.defaultProps = config.defaultProps;
UnavailablePage.propTypes = config.propTypes;

export default UnavailablePage;
